// mui
import Stack from '@mui/material/Stack';

// hooks
import useResponsive from 'hooks/useResponsive';
import useVirgoContent from 'hooks/useVirgoContent';

// components
import CircleCard from './CircleCard';

const Circles = () => {
  const isDesktop = useResponsive('up', 'md');

  const { circles } = useVirgoContent();

  if (!circles?.data || circles?.data?.length <= 0) return null;

  return (
    <div style={{ width: '100%', overflow: 'hidden' }}>
      <Stack
        direction="row"
        alignItems="flex-start"
        columnGap={isDesktop ? '30px' : '20px'}
        justifyContent={isDesktop ? 'center' : 'flex-start'}
        data-testid="fyp-discover-section-container-circles"
        sx={{
          overflowX: 'scroll',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
      >
        {circles?.data?.map((circleData, index) => (
          <CircleCard
            testId={index}
            key={circleData?.id}
            circleData={circleData}
            isLastElement={index === circles.length - 1}
          />
        ))}
      </Stack>
    </div>
  );
};

export default Circles;
